<div class="notification">
  <button
    type="button"
    class="notification__toggle"
    [matMenuTriggerFor]="notificationMenu"
    #menuTrigger="matMenuTrigger"
    aria-label="Show notifications">
    <rms-hover-icon
      [staticIconSVG]="'assets/icons/header/alert-icon.svg'"
      [hoverIconSVG]="'assets/icons/header/alert-icon-bold.svg'"
      [iconHeight]="'19'">
    </rms-hover-icon>
    <span *ngIf="total > 0" class="notification__count">{{ total }}</span>
  </button>

  <mat-menu #notificationMenu="matMenu" class="rms-notifications-menu" xPosition="before">
    <rms-notifications-menu (closeMenu)="closeMenu()"></rms-notifications-menu>
  </mat-menu>
</div>
